import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en';
import es from './locales/es';
import ar from './locales/ar';
import fr from './locales/fr';
import de from './locales/de';
import pt from './locales/pt';
import it from './locales/it';
import ru from './locales/ru';
import zhCN from './locales/zh-CN';
import ja from './locales/ja';
import ko from './locales/ko';
import hi from './locales/hi';
import bn from './locales/bn';

const PANEL_NS = 'panel';

const resources = {
  en: { [PANEL_NS]: en },
  es: { [PANEL_NS]: es },
  ar: { [PANEL_NS]: ar },
  fr: { [PANEL_NS]: fr },
  de: { [PANEL_NS]: de },
  pt: { [PANEL_NS]: pt },
  it: { [PANEL_NS]: it },
  ru: { [PANEL_NS]: ru },
  'zh-CN': { [PANEL_NS]: zhCN },
  ja: { [PANEL_NS]: ja },
  ko: { [PANEL_NS]: ko },
  hi: { [PANEL_NS]: hi },
  bn: { [PANEL_NS]: bn },
};

let initialized = false;

export function initPanelI18n() {
  if (initialized) return i18n;
  initialized = true;
  // Must be sync: hard URL SSR of /user|/agent renders useTranslation before any
  // useEffect. Without init, react-i18next Suspense never resolves → blank page.
  i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    ns: [PANEL_NS],
    defaultNS: PANEL_NS,
    keySeparator: false,
    nsSeparator: false,
    interpolation: { escapeValue: false },
    initImmediate: false,
    react: { useSuspense: false },
  });
  return i18n;
}

// Eager init for Pages Router SSR (manual address-bar loads).
initPanelI18n();

export { PANEL_NS };
export default i18n;
